import { SvgRatingStar } from "assets";
import {
  black,
  gray1,
  gray2,
  gray3,
  gray4,
  gray5,
  gray6,
  gray7,
  gray8,
  kakaoColor,
  mainColor,
  white,
} from "assets/styleUtils";
import { EmptyView, HallInfo, TextSection, TypeText } from "components";
import {
  getCompanyDetail,
  getCompanyReviewList,
  getCompanyReviewPhotoList,
  ICompany,
  ICompanyReview,
  ICompanyReviewPhoto,
} from "data/company";
import { THallList } from "pages/WeddingHall/WeddingHall";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { headerAndBottomVisibleState, userSelectHall } from "recoil/atoms";
import ReviewItem from "./ReviewItem";
import styles from "./style.module.css";
import { toast, ToastContainer } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { getParameterObject } from "utils/common";
import { recombinationListState, selectListState } from "recoil/company";
import { addCart } from "store/data/company";
import useUser from "hooks/useUser";
import { FixedModal } from "modal";
import ProductItem from "./ProductItem";
import ImageItem from "./ImageItem";
import SvgLogoNoback from "assets/svgIcons/SvgLogoNoback";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import { api, getToken } from "utils/ApiUtil";
import { useQuery } from "react-query";
import Lottie from "lottie-react";
import { loadingLottie } from "assets/lottie";
import { MMW_URL } from "assets/constant";

type TInfo = "정보" | "상품" | "리뷰" | "사진";
export const exceptCommentCategories = ["예복", "한복", "예물"];

export default function CompanyDetailPage() {
  const navigation = useNavigate();
  const location = useLocation();
  const headerAndBottomVisible = useRecoilValue(headerAndBottomVisibleState);
  const { isBottom } = headerAndBottomVisible;
  const [companyData, setCompanyData] = useState<ICompany>();
  const [selectInfo, setSelectInfo] = useState<TInfo>("상품");
  const productRef = useRef<HTMLDivElement>(null);
  const infoRef = useRef<HTMLDivElement>(null);
  const photoRef = useRef<HTMLDivElement>(null);
  const reviewTabRef = useRef<HTMLDivElement>(null);
  const isScrollingRef = useRef(false);

  const [reviewList, setReviewList] = useState<{
    page: IPage;
    review: ICompanyReview[];
    totalRating: string;
  }>();
  const [isLoding, setIsLoding] = useState(false);
  const [reviewPhotoList, setReviewPhotoList] = useState<ICompanyReviewPhoto[]>(
    [],
  );
  const [contructorList, setContructorList] = useState<THallList[]>([]);
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);
  const [recoilselectListState, setReoilSelectListState] =
    useRecoilState(selectListState);

  const userHallData = useRecoilValue(userSelectHall);
  const [swiperRef, setSwiperRef] = useState<SwiperCore>();
  const [paging, setPaging] = useState(0);
  const { search } = useLocation();
  const { no } = getParameterObject({ url: search });
  const [category, setCategory] = useState("");
  const categoryisWeddinghall = category === "웨딩홀";
  const recombinationList = useRecoilValue(recombinationListState);
  const { user, getUser } = useUser();
  const [showAlert, setShowAlert] = useState(false);
  const reviewRef = useRef<HTMLDivElement | null>(null);
  const [reviewPage, setReviewPage] = useState(1);
  const categoriesForConnetingKakaotalk = [
    "메이크업",
    "헤어변형",
    "드레스",
    "혼주 메이크업",
  ];

  const booked = recombinationList.filter(
    (data) => data.status !== 3 && data.contructor_no === companyData?.no,
  );

  const selectComplete = contructorList.map((_selectItem) => {
    const filteredHalls =
      _selectItem.hall?.filter((_hall) => _hall.checked) || [];
    return {
      name: _selectItem.name,
      contructor_no: _selectItem.contructor_no,
      hall: filteredHalls,
    };
  });
  const containsEmptyArray = selectComplete.filter((array, idx) => {
    if ((array || []).hall.length === 0) {
      return selectComplete[idx].name;
    }
  });

  const gotoReviewWrite = () => {
    if (user?.status === 2) {
      return toast.error("관리자에 의해 활동이 정지되었습니다.");
    } else {
      navigation("/company/detail/review/reviewwrite", {
        state: {
          contructor_no: companyData?.no,
        },
      });
    }
  };
  async function fetchCompanyData(no: number) {
    const {
      data: { result },
    } = await getCompanyDetail(no);
    return result;
  }
  const { data, error, isLoading } = useQuery(
    ["companyData", no],
    () => fetchCompanyData(Number(no)),
    {
      staleTime: 300000,
      enabled: !!no,
    },
  );

  useEffect(() => {
    const scrollTimeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(scrollTimeout);
  }, [location]);

  useEffect(() => {
    const token = getToken();
    if (token) {
      api.setToken(token);
      getUser();
    }
  }, []);

  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref?.current) {
      isScrollingRef.current = true;
      const topOffset =
        ref.current.getBoundingClientRect().top + window.scrollY - 50;
      window.scrollTo({ top: topOffset, behavior: "smooth" });

      setTimeout(() => {
        isScrollingRef.current = false;
      }, 500);
    }
  };

  useEffect(() => {
    if (data) {
      setCompanyData(data);
      setCategory(data.category);

      const userHall = userHallData.find((hall) => hall.name === data.name);
      const checked = userHall ? userHall.checked : false;

      const newDataState = {
        key: data.no,
        name: data.name,
        imgUrl: data.photo[0]?.img_url || "",
        checked: checked,
        contructor_no: data.no,
        hall: data.hall_list || [],
      };
      setContructorList([{ ...newDataState, checked: true }]);
    }
  }, [data, userHallData]);

  useEffect(() => {
    if (!no) {
      navigation(-1);
    }
  }, [no, navigation]);

  useEffect(() => {
    if (companyData?.review && companyData.review.review.length > 0) {
      setReviewList(companyData.review);
    }
    if (companyData?.no) {
      getReviewPhotoData();
    }
  }, [companyData]);

  async function getReviewData(_page: number) {
    if (reviewList && reviewList.page.maxpage < _page) return;
    try {
      if (_page === 1) {
        setIsLoding(true);
      }
      const { data } = await getCompanyReviewList({
        page: String(_page),
        contructor_no: String(companyData?.no),
      });
      const { review, page } = data.result || {};

      if (data && review && page) {
        if (_page <= 1) {
          setReviewPage(1);
          setReviewList(data.result);
        } else if (_page <= page.maxpage) {
          setReviewPage(page.cur);
          setReviewList((prevReviewList) => ({
            ...data.result,
            review: [...(prevReviewList?.review || []), ...review],
          }));
        } else {
          return;
        }
      }
    } catch (error) {
      console.warn("getReviewData error", error);
    } finally {
      setTimeout(() => setIsLoding(false), 500);
    }
  }

  async function getReviewPhotoData() {
    try {
      const { data } = await getCompanyReviewPhotoList({
        contructor_no: String(companyData?.no),
      });
      if (data.result) {
        setReviewPhotoList(data.result);
      }
    } catch (error) {
      console.warn("getReviewPhotoData error", error);
    }
  }
  useInfiniteScroll({
    page: reviewPage,
    setPage: setReviewPage,
    getData: getReviewData,
    ref: reviewRef,
    totalPages: reviewList?.page?.maxpage || 1,
  });

  const BenefitSection = ({
    benefits,
    type,
    isWeddingHall,
  }: {
    benefits: {
      no: number;
      contructor_no: number;
      type: "make" | "contructor";
      context: string;
    }[];
    type: "contructor" | "make";
    isWeddingHall: boolean;
  }) => (
    <div className={`${styles.benefitSection} ${styles.topBorder}`}>
      <div className={styles.benefitHeader}>
        {type === "make" ? (
          <div className={styles.logoIcon}>
            <SvgLogoNoback />
          </div>
        ) : (
          <img className={styles.ticketIcon} src="/images/ticket.png" />
        )}
        <div className={`${styles.benefitTitle} ${styles.mainColor}`}>
          <div
            className={styles.benefitTitleFlex}
            style={{ marginLeft: "3px" }}
          >
            {type === "make" ? "메이크마이웨딩" : "업체"} 제공 혜택
          </div>
        </div>
      </div>
      <>
        {isWeddingHall
          ? benefits
              .filter((benefit) => benefit.type === "contructor")
              .map(({ context }, index) => (
                <TextSection data={context} key={index} />
              ))
          : benefits
              .filter((benefit) => benefit.type === type)
              .map(({ context }, index) => (
                <TextSection data={context} key={index} />
              ))}
      </>
    </div>
  );

  const CompanyBenefits = ({ companyData }: { companyData?: ICompany }) => {
    const { category, additinal } = companyData || {};

    if (!additinal || additinal.length === 0) {
      return <div style={{ margin: "0 16px" }} />;
    }

    const isWeddingHall = category === "웨딩홀";

    return (
      <>
        {isWeddingHall ? (
          <BenefitSection
            benefits={additinal}
            type="make"
            isWeddingHall={true}
          />
        ) : (
          <>
            <BenefitSection
              benefits={additinal}
              type="make"
              isWeddingHall={false}
            />
            <BenefitSection
              benefits={additinal}
              type="contructor"
              isWeddingHall={false}
            />
          </>
        )}
      </>
    );
  };
  const [isFixed, setIsFixed] = useState(false);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [originalTop, setOriginalTop] = useState(0);

  useEffect(() => {
    const measureOffsetTop = () => {
      if (headerRef.current) {
        setOriginalTop(headerRef.current?.offsetTop);
      }
    };
    setTimeout(() => {
      requestAnimationFrame(measureOffsetTop);
    }, 500);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current && !isScrollingRef.current) {
        const currentScrollY = window.scrollY;

        if (currentScrollY > originalTop && !isFixed) {
          setIsFixed(true);
        } else if (currentScrollY <= originalTop && isFixed) {
          setIsFixed(false);
          setSelectInfo("상품");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFixed, originalTop]);
  useEffect(() => {
    const sections = [
      { ref: productRef, name: "상품", id: "productRef" },
      { ref: infoRef, name: "정보", id: "infoRef" },
      { ref: photoRef, name: "사진", id: "photoRef" },
      { ref: reviewTabRef, name: "리뷰", id: "reviewTabRef" },
    ];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = sections.find(
              (section) => section.ref.current?.id === entry.target.id,
            );
            if (section && window.scrollY >= 300 && !isScrollingRef.current) {
              setSelectInfo(section.name as TInfo);
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    sections.forEach((section) => {
      if (section.ref.current) {
        observer.observe(section.ref.current);
      }
    });

    return () => {
      sections.forEach((section) => {
        if (section.ref.current) {
          observer.unobserve(section.ref.current);
        }
      });
    };
  }, [productRef, infoRef, photoRef, reviewTabRef]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get("section");

    if (section) {
      setTimeout(() => {
        if (section === "photo") {
          setSelectInfo("사진");
          scrollToSection(photoRef);
        } else if (section === "product") {
          setSelectInfo("상품");
          scrollToSection(productRef);
        } else if (section === "info") {
          setSelectInfo("정보");
          scrollToSection(infoRef);
        } else if (section === "review") {
          setSelectInfo("리뷰");
          scrollToSection(reviewTabRef);
        }
      }, 500);
    }
  }, [location.search]);

  return (
    <>
      {showAlert && (
        <FixedModal
          title={"안내사항"}
          sub={
            "당일 노쇼 또는 반복된 취소로 패널티가 \n부여되어 메이크마이웨딩 제휴 업체 \n예약 문의가 불가합니다. \n또한 당일 노쇼 또는 반복된 취소 시, \n해당 업체 정책에 의거하여 업체에 직접 예약하실 경우에도 재예약 및 상담이 어려울 수 있으니 참고 부탁 드립니다."
          }
          oneButton={{
            color: gray4,
            text: "뒤로가기",
            onClick: () => setShowAlert(false),
          }}
          onClick={() => setShowAlert(false)}
        />
      )}

      <div>
        {!companyData?.thumb_photo[0] ? (
          <div style={{ width: "100%", height: "260px" }}>
            <EmptyView content="사진이 없습니다" />
          </div>
        ) : (
          <div>
            <>
              <Swiper
                spaceBetween={120}
                className="mySwiper"
                slidesPerView="auto"
                threshold={10}
                pagination={{
                  dynamicBullets: true,
                }}
                onSwiper={setSwiperRef}
                modules={[Pagination]}
                onSlideChange={(swiper) => setPaging(swiper.activeIndex)}
                style={{ backgroundColor: white }}
              >
                {companyData.thumb_photo?.map((_photo, index) => {
                  return (
                    <SwiperSlide key={index} style={{ display: "block" }}>
                      <img
                        src={_photo.img_url}
                        style={{
                          height: "375px",
                          objectFit: "contain",
                          width: "100%",
                        }}
                      ></img>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </>
            <div
              style={{
                marginTop: "24px",
                padding: "0 16px 20px 16px",
              }}
            >
              <div style={{ justifyContent: "space-between" }}>
                <div>
                  <div style={{ fontSize: "12px", color: gray3 }}>
                    {(companyData?.address || "주소정보없음")
                      .split(" ")
                      .filter(({}, i) => i < 2)
                      .join(" ")}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        margin: "8px 0",
                      }}
                    >
                      {companyData?.name}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        onClick={() => {
                          if (window.navigator.share) {
                            window.navigator.share({
                              url: `https://www.makemywedding-pc.co.kr/company/detail?no=${companyData?.no}`,
                            });
                          } else {
                            window.navigator.clipboard.writeText(
                              `https://www.makemywedding-pc.co.kr/company/detail?no=${companyData?.no}`,
                            );
                            toast.success("링크가 복사되었습니다.");
                          }
                        }}
                      >
                        <img
                          src="/images/share.png"
                          style={{ marginRight: "4px", width: "24px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ fontSize: "12px", color: gray4 }}>
                    {companyData?.tag
                      .split(",")
                      .reduce<string>((acc, cur) => acc + `#${cur} `, "")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <CompanyBenefits companyData={companyData} />
        <div
          ref={headerRef}
          style={{
            display: "flex",
            height: "44px",
            padding: "0 24px",
            justifyContent: "space-between",
            position: isFixed ? "fixed" : "static",
            top: isFixed ? "0" : "auto",
            width: "100%",
            maxWidth: "540px",
            backgroundColor: "white",
            zIndex: 999,
          }}
        >
          {(
            (categoryisWeddinghall
              ? ["상품", "정보", "리뷰"]
              : ["상품", "정보", "사진", "리뷰"]) as TInfo[]
          ).map((text, index) => {
            const isSelect = text === selectInfo;
            return (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderBottom: isSelect ? `2px solid ${gray1}` : "",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSelectInfo(text);
                  if (text === "상품") scrollToSection(productRef);
                  else if (text === "정보") scrollToSection(infoRef);
                  else if (text === "사진") scrollToSection(photoRef);
                  else if (text === "리뷰") scrollToSection(reviewTabRef);
                }}
                key={index}
              >
                <div
                  style={{
                    color: isSelect ? gray1 : gray5,
                    fontWeight: "500",
                    display: "flex",
                  }}
                >
                  {text}
                  {text === "리뷰" &&
                    reviewList?.page.maxcnt &&
                    reviewList?.page.maxcnt > 0 && (
                      <div color={isSelect ? gray1 : gray5}>
                        ({reviewList?.page.maxcnt})
                      </div>
                    )}
                </div>
              </div>
            );
          })}
        </div>
        <div
          style={{
            padding: "24px 16px",
          }}
        >
          {category === "웨딩홀" ? (
            <div>
              <div
                className={styles.productTitle}
                ref={productRef}
                id="productRef"
              >
                상품
              </div>
              {(companyData?.hall_list || []).length > 0 ? (
                <div style={{ background: "#f2f9f8", padding: "13px 12px" }}>
                  <HallInfo
                    hall={contructorList[0].hall || []}
                    contructor_no={Number(no)}
                    setValue={({ contructor_no: no, contructor_hall_no }) => {
                      const contructorData = contructorList.map(
                        (list, index) => {
                          return {
                            ...list,
                            hall: list.hall?.map((_hall, index) =>
                              _hall.no === contructor_hall_no
                                ? {
                                    ..._hall,
                                    checked: !_hall.checked,
                                  }
                                : _hall,
                            ),
                          };
                        },
                      );
                      setContructorList(contructorData);
                      if (!contructorData) {
                        return;
                      }
                    }}
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                  }}
                >
                  <EmptyView content="상품이 없습니다" />
                </div>
              )}
            </div>
          ) : (
            <>
              <div
                className={styles.productTitle}
                ref={productRef}
                id="productRef"
              >
                상품
              </div>
              <div className={styles.productStyle}>
                {companyData?.productitem?.main.map((product, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        marginBottom:
                          companyData.productitem &&
                          index < companyData.productitem.main.length - 1
                            ? "12px"
                            : "0px",
                      }}
                    >
                      <ProductItem
                        productItme={product}
                        category={companyData.category}
                        specialCategories={categoriesForConnetingKakaotalk}
                      />
                    </div>
                  );
                })}
              </div>
              {(companyData?.productitem?.option || []).length > 0 && (
                <>
                  <div
                    className={styles.productTitle}
                    style={{ marginTop: "10px" }}
                  >
                    옵션
                  </div>

                  <div className={styles.productStyle}>
                    {companyData?.productitem?.option.map((_option, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            marginBottom:
                              companyData.productitem &&
                              index < companyData.productitem.option.length - 1
                                ? "12px"
                                : "0px",
                          }}
                        >
                          <ProductItem
                            productItme={_option}
                            category={companyData.category}
                            specialCategories={categoriesForConnetingKakaotalk}
                          />
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </>
          )}
          <div className={styles.refStyle}>
            <div ref={infoRef} id="infoRef"></div>
            <div className={styles.productTitle}>업체 소개</div>
            <div style={{ marginBottom: "24px", lineHeight: "25px" }}>
              <TextSection data={companyData?.coment || ""} />
            </div>
            <TypeText
              title="영업시간"
              content={companyData?.openhour || "정보 없음"}
            />
            <TypeText
              title="휴무일"
              content={companyData?.restday || "정보 없음"}
            />
            <TypeText
              title="주소"
              content={companyData?.address || "정보 없음"}
            />
            <TypeText
              title="홈페이지"
              content={companyData?.homepageUrl || "-"}
              action={companyData?.homepageUrl}
            />
            <TypeText
              title="인스타그램"
              content={companyData?.instagramUrl || "-"}
              action={
                companyData?.instagramUrl &&
                "https://www.instagram.com/" + companyData?.instagramUrl
              }
            />
          </div>
          {!categoryisWeddinghall && (
            <div className={styles.refStyle} ref={photoRef} id="photoRef">
              <div
                style={{
                  marginBottom: "10px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: mainColor,
                }}
              >
                {companyData?.youtube_thumbnail && companyData.youtube_url && (
                  <div className={styles.thumbnailContainer}>
                    <a href={companyData.youtube_url} target="_blank">
                      <img
                        src={companyData.youtube_thumbnail}
                        className={styles.thumbnailImage}
                      />
                      <div className={styles.playButton}></div>
                    </a>
                  </div>
                )}

                {(companyData?.product || []).length > 0 ? (
                  <ImageItem companyData={companyData} />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  >
                    <EmptyView content={"사진이 없습니다"} />
                  </div>
                )}
              </div>
            </div>
          )}
          <div className={styles.refStyle}>
            <div ref={reviewTabRef} id="reviewTabRef" />
            {reviewList && reviewList.review.length > 0 ? (
              <>
                <div
                  style={{
                    flexDirection: "row",
                    marginBottom: "16px",
                    padding: "0 6px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                      padding: "10px 0",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className={styles.flexCenter}
                      style={{
                        height: "120px",
                        flexDirection: "column",
                        backgroundColor: gray8,
                        borderRadius: "8px",
                        padding: "0 12px",
                      }}
                    >
                      {reviewList?.totalRating && (
                        <>
                          <div
                            style={{
                              lineHeight: "39px",
                              fontSize: "30px",
                              fontWeight: "bold",
                              marginBottom: "5px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {!!reviewList?.totalRating &&
                              parseFloat(reviewList?.totalRating).toFixed(1)}
                          </div>
                          <div
                            style={{
                              flexDirection: "row",
                              height: "20px",
                            }}
                          >
                            <div
                              style={{
                                flexDirection: "row",
                                alignItems: "baseline",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "baseline",
                                  width: "100px",
                                }}
                              >
                                <SvgRatingStar
                                  width="100px"
                                  height="20px"
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                  }}
                                  fill={mainColor}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "3px",
                          height: "60px",
                          backgroundColor: gray6,
                        }}
                      />
                    </div>
                    <div>
                      <div
                        className={styles.flexCenter}
                        style={{
                          border: `1px solid ${mainColor}`,
                          borderRadius: "4px",
                          padding: "12px 10px",
                          marginBottom: "8px",
                        }}
                        onClick={() => gotoReviewWrite()}
                      >
                        <div
                          className={styles.flexCenter}
                          style={{
                            fontSize: "14px",
                            lineHeight: "21px",
                            fontWeight: "bold",
                            color: mainColor,
                          }}
                        >
                          리뷰 작성하러 가기
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                          fontWeight: "500",
                          color: gray5,
                          whiteSpace: "pre-line",
                          textAlign: "center",
                        }}
                      >
                        {
                          "일반리뷰 작성시 500포인트 지급 \n 포토리뷰 작성시 1,000포인트 지급"
                        }
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      border: `1px solid ${gray7}`,
                    }}
                  />
                  {reviewPhotoList.length > 0 && (
                    <>
                      <div className={styles.paddingBox}>
                        <div
                          style={{
                            fontSize: "16px",
                            lineHeight: "24px",
                            color: gray1,
                          }}
                        >
                          사진 리뷰 모아보기
                        </div>
                      </div>
                      <div className={styles.borderBox} />
                      <div className={styles.paddingBox}>
                        <div
                          className={styles.reviewImageScroll}
                          style={{
                            overflowX:
                              reviewPhotoList.length > 2 ? "scroll" : "hidden",
                          }}
                        >
                          {reviewPhotoList.map((item, i) => (
                            <img
                              key={i}
                              src={item.img_url}
                              className={styles.reviewImage}
                            />
                          ))}
                        </div>
                      </div>
                      <div className={styles.borderBox} />
                    </>
                  )}
                  <div className={styles.paddingBox}>
                    리뷰 {reviewList?.page.maxcnt}
                  </div>
                  <div className={styles.borderBox} />

                  <div>
                    {reviewList.review.map((item) => (
                      <div
                        key={item.no}
                        onClick={() =>
                          item.blind_yn === "N" &&
                          navigation(
                            `/company/detail/review/${item.no}/${item.contructor_no}`,
                          )
                        }
                      >
                        <ReviewItem review={item} />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <EmptyView
                  content={
                    "리뷰가 없습니다.\n 첫 번째 리뷰를 작성하러 가볼까요?"
                  }
                />
                <div
                  className={styles.flexCenter}
                  style={{
                    border: `1px solid ${mainColor}`,
                    borderRadius: "4px",
                    padding: "12px 10px",
                    marginBottom: "8px",
                  }}
                  onClick={() => gotoReviewWrite()}
                >
                  <div
                    className={styles.flexCenter}
                    style={{
                      fontSize: "14px",
                      lineHeight: "21px",
                      fontWeight: "bold",
                      color: mainColor,
                      cursor: "pointer",
                    }}
                  >
                    리뷰 작성하러 가기
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    lineHeight: "18px",
                    fontWeight: "500",
                    color: gray5,
                    whiteSpace: "pre-line",
                    textAlign: "center",
                  }}
                >
                  {
                    "일반리뷰 작성시 500포인트 지급 \n 포토리뷰 작성시 1,000포인트 지급"
                  }
                </div>
              </div>
            )}
          </div>
        </div>
        <>
          {((reviewList && reviewList.review) || []).length > 8 && (
            <div ref={reviewRef} />
          )}
        </>
        <div style={{ height: "100px" }} />

        <nav className={styles.nav}>
          <div>
            <div
              style={{
                display: "flex",
                height: "60px",
                padding: "8px",
                alignItems: "center",
              }}
            >
              {categoriesForConnetingKakaotalk.includes(category) && (
                <a
                  className={styles.buttonStyle}
                  style={{
                    backgroundColor: "#ff8e89",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  target="_blank"
                  href={MMW_URL.kakao}
                >
                  견적 문의
                </a>
              )}
              {!!isBottom && (
                <div
                  className={`${styles.flexCenter} ${styles.buttonStyle}`}
                  style={{
                    backgroundColor: black,
                  }}
                  onClick={async () => {
                    try {
                      if (companyData) {
                        const res = await addCart({
                          contructor_no: companyData?.no,
                        });
                        if (res.success) {
                          return toast.success("장바구니에 담겼습니다.");
                        } else {
                          return toast.error(res.message);
                        }
                      }
                    } catch (error) {
                      return toast.error(
                        error instanceof Error
                          ? error.message
                          : "에러가 발생했습니다. 관리자에게 문의해주세요.",
                      );
                    }
                  }}
                >
                  장바구니 담기
                </div>
              )}
              <div
                className={`${styles.flexCenter} ${styles.buttonStyle}`}
                style={{
                  backgroundColor: mainColor,
                }}
                onClick={() => {
                  if (!user) {
                    return navigation("/SignIn");
                  }
                  if (
                    (companyData?.category !== "웨딩홀" &&
                      user?.other_block_yn === "Y") ||
                    (companyData?.category === "웨딩홀" &&
                      user?.wedding_block_yn === "Y")
                  ) {
                    return setShowAlert(true);
                  }
                  if (categoryisWeddinghall) {
                    if (booked.length > 0) {
                      return toast.error(
                        categoryisWeddinghall
                          ? "이미 예약 신청하신 웨딩홀은 재예약이 불가합니다. \n[내정보-웨딩홀 예약관리]에서 예약 취소 혹은 변경 부탁드립니다."
                          : "해당업체에 예약 신청 및 취소 이력이 있으셔서 추가 접수는 불가합니다. 재예약을 원하시는 경우 챗봇으로 신청해 주세요! :)",
                      );
                    }
                    if (
                      categoryisWeddinghall &&
                      containsEmptyArray.length > 0
                    ) {
                      toast(
                        containsEmptyArray[0].name + ` 홀타입 선택해주세요`,
                      );
                      return;
                    } else {
                      setSelectArray(contructorList);
                      navigation(`/wedding/hall?txt=${companyData?.name}`);
                    }
                  } else {
                    if (companyData?.spotlist?.length) {
                      const { spotlist, no } = companyData;
                      const firstSpot = spotlist[0];
                      if (spotlist.length === 1) {
                        if (firstSpot.reservation_type === "in") {
                          navigation(
                            `/company/detail/insertEntryInfoPage?no=${no}`,
                          );
                        } else if (
                          ["kakao", "site"].includes(firstSpot.reservation_type)
                        ) {
                          return window.open(firstSpot.reservation_url);
                        }
                      }

                      if (companyData.spotlist.length > 1) {
                        setReoilSelectListState((prev) => ({
                          ...prev,
                          spotList: companyData.spotlist,
                        }));
                        navigation(
                          `/company/detail/Spotlist?category=${category}&contructor_no=${companyData?.no}`,
                        );
                      }
                    } else if (category === "예복" || category === "한복") {
                      navigation(
                        `/company/detail/SelectClothes?category=${category}&contructor_no=${companyData?.no}`,
                      );
                    } else {
                      navigation(
                        `/company/detail/insertEntryInfoPage?no=${companyData?.no}`,
                      );
                    }
                  }
                }}
              >
                예약하기
              </div>
            </div>
          </div>
        </nav>
        <ToastContainer
          position="bottom-center"
          limit={1}
          closeButton={false}
          autoClose={1000}
          theme="light"
        />
      </div>
    </>
  );
}
